import { render, staticRenderFns } from "./register-from.vue?vue&type=template&id=7caf70f2&scoped=true"
import script from "./register-from.vue?vue&type=script&lang=js"
export * from "./register-from.vue?vue&type=script&lang=js"
import style0 from "./register-from.vue?vue&type=style&index=0&id=7caf70f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf70f2",
  null
  
)

export default component.exports